export function useModuleControls(onSuccess)
{
    return {
        uninstallModule: (id) => fetch(`/admin/api/uninstall-module/${id}`, { method: "POST", credentials: "include" }).then(r => { if (r.ok) onSuccess(); }),
        loadModule: (id) => fetch(`/admin/api/load-module/${id}`, { method: "POST", credentials: "include" }).then(r => { if (r.ok) onSuccess(); }),
        unloadModule: (id) => fetch(`/admin/api/unload-module/${id}`, { method: "POST", credentials: "include" }).then(r => { if (r.ok) onSuccess(); })
    }
}